<template v-if="locale.billing">
  <div class="billing" id="billing">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
      <h1>{{locale.billing.billing}}</h1>
    </div>
    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
            <th scope="col">{{locale.billing.timeframe}}</th>
            <th scope="col">{{locale.billing.price}}</th>
        </tr>
        </thead>
        <tbody>
          <template v-for="billing in billingList">
            <tr :key="billing.id">
              <td data-label="Data">
                  <a href="#" v-on:click="getPdfBilling({'number': billing.number })" title="">{{billing.begin}} - {{billing.end}} </a>
              </td>
              <td data-label="Action" class="bill-action-btn">
                  {{billing.sum}}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Billing',
  computed: {
    ...mapState(['locale']),
    ...mapState({
      billingList: state => state.billing.billingList,
      loadingState: state => state.loadingState
    })
  },
  methods: {
    ...mapActions({
      'getPdfBilling': 'billing/getPdfBilling'
    })
  },
  mounted () {
    this.$store.dispatch('billing/getBillingList')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Billing.vue